import { render, staticRenderFns } from "./RoomControlAir.vue?vue&type=template&id=30db1eff&scoped=true"
import script from "./RoomControlAir.vue?vue&type=script&lang=js"
export * from "./RoomControlAir.vue?vue&type=script&lang=js"
import style0 from "./RoomControlAir.vue?vue&type=style&index=0&id=30db1eff&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db1eff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30db1eff')) {
      api.createRecord('30db1eff', component.options)
    } else {
      api.reload('30db1eff', component.options)
    }
    module.hot.accept("./RoomControlAir.vue?vue&type=template&id=30db1eff&scoped=true", function () {
      api.rerender('30db1eff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/control/components/RoomControlAir.vue"
export default component.exports